import Icon from '../../components/Icon.vue'

Icon.register({"brands/digg":{"width":512,"height":512,"paths":[{"d":"M81.7 172.3H0V346.7H132.7V96H81.7V172.3zM81.7 305.7H50.9V213.4H81.7V305.7zM378.9 172.3V346.7H460.7V375.2H378.9V416H512V172.3H378.9zM460.7 305.7H429.9V213.4H460.7V305.7zM225.1 346.7H307.2V375.2H225.1V416H358.4V172.3H225.1V346.7zM276.3 213.4H307.1V305.7H276.3V213.4zM153.3 96H204.6V147H153.3V96zM153.3 172.3H204.6V346.7H153.3V172.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/digg.js
// module id = null
// module chunks = 